export default __webpack_public_path__ + "static/media/handprint-14-15-page.dc5de568.png";